import { render, staticRenderFns } from "./Aristotle.vue?vue&type=template&id=20f06df0&scoped=true"
import script from "./Aristotle.vue?vue&type=script&lang=js"
export * from "./Aristotle.vue?vue&type=script&lang=js"
import style0 from "./Aristotle.vue?vue&type=style&index=0&id=20f06df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f06df0",
  null
  
)

export default component.exports